






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import { DxDataGrid, DxColumn, DxEditing, DxStateStoring, DxRequiredRule } from 'devextreme-vue/data-grid';

@Component({
  components: {
    cCard,
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
    DxStateStoring,
  },
})
export default class RawMaterialsCompositionCard extends Vue {
  @Prop({ required: true })
  public value!: IArticleBillOfMaterialLine[];

  editableValue: IArticleBillOfMaterialLine[] = [];

  mounted() {
    this.editableValue = Object.assign([], this.value);
  }

  add() {
    const table: any = this.$refs.articleBomTable;
    table.instance.addRow();
  }

  async onRowUpdated(e: any) {
    notificationService.saved();
    this.$emit('input', this.editableValue);
  }

  get articles() {
    return this.$store.getters['articles/items'] as IArticle[];
  }

  get columns() {
    const self = this;
    return [
      {
        dataField: 'objectId',
        caption: 'Code',
        lookup: {
          dataSource: this.articles,
          displayExpr: 'name',
          valueExpr: 'id',
        },
        editorOptions: {
          searchEnabled: 'true',
          showClearButton: 'true',
        },
        validationRules: [
          {
            type: 'required',
            message: 'Dit veld is verplicht!',
          },
        ],
      },
      {
        caption: this.$t('objects.articles.MeasuringUnit'),
        alignment: 'left',
        calculateCellValue(value: any) {
          if (!value || !self.articles || !value.objectId || value.objectId === '') {
            return '';
          }

          const article = self.articles.find((o: any) => o.id === value.objectId);
          return article ? article.measuringUnit : '';
        },
      },
      {
        dataField: 'amount',
        caption: this.$t('objects.articles.Amount'),
        dataType: 'number',
        alignment: 'left',
        validationRules: [
          {
            type: 'required',
            message: 'Dit veld is verplicht!',
          },
        ],
      },
    ];
  }
}
